webpackJsonp([6],{

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1362796c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_arrow.09476cf.png";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(504);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1cc57730", content, true);

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".title{margin:0;padding:0;height:5rem;background:#fff}.title img,.title p{display:block;height:5rem}.title img{width:100%}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadHeader.vue"],"names":[],"mappings":"AACA,OACE,SAAU,AACV,UAAW,AACX,YAAa,AACb,eAAiB,CAClB,AAKD,oBAHE,cAAe,AACf,WAAa,CAMd,AAJD,WACE,UAAY,CAGb","file":"downloadHeader.vue","sourcesContent":["\n.title {\n  margin: 0;\n  padding: 0;\n  height: 5rem;\n  background: #fff;\n}\n.title p {\n  display: block;\n  height: 5rem;\n}\n.title img {\n  width: 100%;\n  height: 5rem;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headerTitle',
    data: function data() {
        var query = this.$route.query || {};
        return {
            imageSrc: query && (query.language === 'en' || query.language === 'es') ? __webpack_require__(506)("./header-" + query.language + '.jpg') : __webpack_require__(509),
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
        };
    },
    mounted: function mounted() {
        var utilObj = __webpack_require__(500);
        utilObj.checkOperamini();
        if (utilObj.checkOperamini()) {
            ga('send', 'event', 'm', 'browers', 'opreamini');
        }
    },

    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(500);
            utilObj.checkOperamini();
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'download', 'opreamini');
            }
            fbq('track', 'Lead');
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.iPad = ua.match(/ipad/);
            browers.iPhone = ua.match(/iphone/);
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            browers.ie = ua.match(/iemobile/);
            browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
            browers.force_ssl = ua.match(/Android (5|6)/i);
            browers.is_ios_6 = ua.match(/iOS 6/i);
            browers.is_liveapp = ua.match(/LiveApp/i);
            if (browers.iOS) {
                utilObj.jumpUrl();
            } else if (browers.Android) {
                location.href = '/download';
            }
        }
    }
});

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./header-en.jpg": 507,
	"./header-es.jpg": 508
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-en.3375c0e.jpg";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-es.fac9b76.jpg";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header.93b20d6.png";

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isInApp) ? _vm._m(0) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', {
    on: {
      "click": _vm.jumpUrl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.imageSrc),
      "alt": "download All Football App",
      "width": "100%"
    }
  })])])
}]}

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ff868c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1eb036a8", content, true);

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#download-popup[data-v-5ff868c8]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;background-color:rgba(0,0,0,.6)}#download-popup .popup-body[data-v-5ff868c8]{position:relative;width:75%;height:200px;margin:0 auto;margin-top:10rem;background-size:100%}#download-popup .popup-body-head[data-v-5ff868c8]{display:block;width:140px;margin:0 auto}#download-popup .popup-body-content[data-v-5ff868c8]{margin-top:-45px;padding-bottom:10px;border-radius:5px;background:#fff}#download-popup .popup-body-clsoe[data-v-5ff868c8]{position:absolute;top:-.5rem;right:-.5rem;width:2.6rem;height:2.6rem;line-height:1.6rem}#download-popup .popup-body-go[data-v-5ff868c8]{display:block;width:90%;height:2.6rem;margin:0 auto;margin-top:5px;color:#fff;text-align:center;line-height:2.6rem;border-radius:5px;font-weight:800;background-color:#25c023}#download-popup .popup-body-text[data-v-5ff868c8]{padding:0 10px;padding-top:50px;margin-bottom:15px;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadPopup.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,+BAAqC,CACtC,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,oBAAsB,CACvB,AACD,kDACE,cAAe,AACf,YAAa,AACb,aAAe,CAChB,AACD,qDACE,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,gDACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kDACE,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadPopup.vue","sourcesContent":["\n#download-popup[data-v-5ff868c8] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n#download-popup .popup-body[data-v-5ff868c8] {\n  position: relative;\n  width: 75%;\n  height: 200px;\n  margin: 0 auto;\n  margin-top: 10rem;\n  background-size: 100%;\n}\n#download-popup .popup-body-head[data-v-5ff868c8] {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n#download-popup .popup-body-content[data-v-5ff868c8] {\n  margin-top: -45px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  background: #fff;\n}\n#download-popup .popup-body-clsoe[data-v-5ff868c8] {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 2.6rem;\n  height: 2.6rem;\n  line-height: 1.6rem;\n}\n#download-popup .popup-body-go[data-v-5ff868c8] {\n  display: block;\n  width: 90%;\n  height: 2.6rem;\n  margin: 0 auto;\n  margin-top: 5px;\n  color: #fff;\n  text-align: center;\n  line-height: 2.6rem;\n  border-radius: 5px;\n  font-weight: 800;\n  background-color: #25c023;\n}\n#download-popup .popup-body-text[data-v-5ff868c8] {\n  padding: 0 10px;\n  padding-top: 50px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            popup_show: false,
            popup_text: 'Download All Football App to enjoy the best football experience',
            popp_btn: true,
            now_local_date: new Date().toLocaleDateString()
        };
    },
    mounted: function mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        this.recodePopupState();
    },

    methods: {
        closePopop: function closePopop() {
            this.popup_show = false;
            var start_date = sessionStorage.getItem('start_date');
            var end_time = new Date().valueOf();
        },
        goDownload: function goDownload() {
            sessionStorage.setItem('loop_run', 'true');
            this.popup_show = false;
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                location.href = '/download';
            } else if (browers.iOS) {
                var utilObj = __webpack_require__(500);
                utilObj.jumpUrl();
            }
        },
        recodePopupState: function recodePopupState() {
            if (!localStorage.getItem('local_date')) {
                this.showPopup();
            } else {
                var local_date = localStorage.getItem('local_date');
                if (local_date != this.now_local_date) {
                    this.showPopup();
                } else {
                    return;
                }
            }
            if (!sessionStorage.getItem('start_date')) {
                var start_date = new Date().valueOf();
                sessionStorage.setItem('start_date', start_date);
            }
        },
        showPopup: function showPopup(is_stop) {
            var that = this;
            var type = this.$route.query && this.$route.query.type;
            var isInApp =  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL;
            var loopFn = function loopFn() {
                if (isInApp) {
                    return;
                }

                var start_date = sessionStorage.getItem('start_date');
                var end_time = new Date().valueOf();
                if (sessionStorage.getItem('loop_run') == 'true') {
                    clearInterval(loopFnTimer);
                }
                if ((end_time - start_date) / 1000 >= 30 && (end_time - start_date) / 1000 < 32) {
                    that.popup_show = true;
                } else if ((end_time - start_date) / 1000 >= 60 && (end_time - start_date) / 1000 < 62) {
                    clearInterval(loopFnTimer);

                    if (type === 'share') {
                        return;
                    }
                    if (document.cookie.indexOf('utm_source=ALL_FOOTBALL_PWA')) {
                        return;
                    }
                    var browers = {};
                    var ua = navigator.userAgent.toLowerCase();
                    browers.Android = ua.match(/android/);
                    browers.iOS = ua.match(/ipad|iphone|ios/);
                    if (browers.Android) {
                        that.popup_text = 'Add our website to Home screen or Bookmarks to follow the latest football news.';
                    } else if (browers.iOS) {
                        that.popup_text = 'Add our website to Home screen or Favorites to follow the latest football news.';
                    }
                    that.popp_btn = false;
                    that.popup_show = true;
                    localStorage.setItem('local_date', that.now_local_date);
                } else if ((end_time - start_date) / 1000 > 62) {
                    clearInterval(loopFnTimer);
                }
            };
            var loopFnTimer = setInterval(loopFn, 1000);
        }
    }
});

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": __webpack_require__(516),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popp_btn),
      expression: "popp_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": function($event) {
        _vm.goDownload()
      }
    }
  }, [_vm._v("GO NOW")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-clsoe",
    attrs: {
      "src": __webpack_require__(517)
    },
    on: {
      "click": function($event) {
        _vm.closePopop()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_icon.c1b2864.png";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close_icon.9c943d6.png";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(519);


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(185);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(124);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon.c67c881.png";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Stats_nulldata.7615563.png";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50de6be9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(526);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("ed09ac36", content, true);

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".nav[data-v-50de6be9]{margin:0;padding:0;height:2.4rem;background:#16b13a;line-height:2.4rem;overflow:hidden}.nav a[data-v-50de6be9]{width:24.3%;text-align:center;color:#fff;font-size:.9rem;float:left;text-decoration:none!important;position:relative;height:1.4rem;line-height:1.4rem;padding:.5rem 0;overflow:hidden;font-weight:700;-webkit-tap-highlight-color:rgba(0,0,0,0)}.selected[data-v-50de6be9]{display:inline-block;width:.5rem;height:.4rem;line-height:1.2rem;background:url(" + __webpack_require__(501) + ") no-repeat;background-size:100% auto;position:absolute;bottom:-.1rem;left:50%;margin-left:-.2rem;z-index:10}.newsSubTit[data-v-50de6be9]{height:2.2rem;width:100%;font-size:.68rem;line-height:2.5rem;text-align:center;color:#2d2f32;border-bottom:.01rem solid #eff1f4;background:#fff}.newsSubTit p[data-v-50de6be9]{height:2.4rem;overflow:scroll;white-space:nowrap;padding:0 .8rem;position:relative;top:0;-webkit-overflow-scrolling:touch}[data-v-50de6be9]:not(html){-webkit-transform:translateZ(0)}.newsSubTit a[data-v-50de6be9]{display:inline-block;padding:0 .7rem;position:relative;height:1.1rem;line-height:1.1rem;padding:.3rem .7rem;color:#2d2f32;font-size:.9rem;-webkit-tap-highlight-color:rgba(0,0,0,0)}.newsSubTit p[data-v-50de6be9]::-webkit-scrollbar{display:none}.subTitSelected[data-v-50de6be9]{color:#16b13a!important;border-bottom:.15rem solid #16b13a}.thirdTitwrap[data-v-50de6be9]{height:3.2rem;background:#333d46;overflow:hidden;color:#929cad}.thirdTit[data-v-50de6be9]{height:1.5rem;width:94%;margin:.8rem auto;line-height:1.5rem;border:1px solid #1d2328;border-radius:.01rem}.thirdTit a[data-v-50de6be9]{width:25%;color:#929cad;float:left;text-align:center;border-right:1px solid #1d2328;text-decoration:none;box-sizing:border-box;height:1.5rem;line-height:1.5rem;font-size:.8rem;padding:0}.thirdTitWidth[data-v-50de6be9]{width:33.3%!important}.thirdTit>a.thirdTitSelected[data-v-50de6be9]{background:#1d2328!important;color:#fff!important}.thirdTit>a[data-v-50de6be9]:last-of-type{border-right:none}.topFixedWrap[data-v-50de6be9]{width:100%;z-index:100;position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0}.main>.tab-box-fixed[data-v-50de6be9]{position:fixed!important;z-index:10;top:0;left:0}.main>.tab-box-testFix[data-v-50de6be9]{z-index:10;top:0;left:0}.tab-box-sticky[data-v-50de6be9]{position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0;left:0;z-index:10}.pad[data-v-50de6be9]{margin:0 3rem}.nav-new a[data-v-50de6be9]{width:18%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:right;-ms-flex-pack:right;justify-content:right}.nav-new a .selected[data-v-50de6be9]{margin-left:.6rem!important}.new-logo-wrap[data-v-50de6be9]{font-family:sans-serif;font-weight:bolder;font-size:.88rem;color:#fff;float:left;margin-left:.4rem;letter-spacing:-1px}.new-logo-wrap .logo-new[data-v-50de6be9]{width:.9rem;margin-right:.2rem;top:.1rem;position:relative}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/navNew.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,mBAAoB,AACpB,eAAiB,CAClB,AACD,wBACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,gBAAkB,AAClB,WAAY,AACZ,+BAAiC,AACjC,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,AAClB,yCAA8C,CAC/C,AACD,2BACE,qBAAsB,AACtB,YAAa,AACb,aAAc,AACd,mBAAoB,AACpB,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,cAAgB,AAChB,SAAU,AACV,mBAAqB,AACrB,UAAY,CACb,AACD,6BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,mCAAqC,AACrC,eAAiB,CAClB,AACD,+BACE,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,MAAU,AACV,gCAAkC,CACnC,AACD,4BACE,+BAAwC,CACzC,AACD,+BACE,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,oBAAqB,AACrB,cAAe,AACf,gBAAiB,AACjB,yCAA8C,CAC/C,AACD,kDACE,YAAc,CACf,AACD,iCACE,wBAA0B,AAC1B,kCAAoC,CACrC,AAED,+BACE,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,aAAe,CAChB,AACD,2BACE,cAAe,AACf,UAAW,AACX,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAuB,CACxB,AACD,6BACE,UAAW,AACX,cAAe,AAEf,WAAY,AACZ,kBAAmB,AACnB,+BAAgC,AAChC,qBAAsB,AACtB,sBAAuB,AACvB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,SAAW,CACZ,AACD,gCACE,qBAAwB,CACzB,AACD,8CACE,6BAA+B,AAC/B,oBAAuB,CACxB,AACD,0CACE,iBAAmB,CACpB,AAED,+BACE,WAAY,AACZ,YAAa,AACb,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,KAAU,CACX,AACD,sCACE,yBAA2B,AAC3B,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,wCACE,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,sBACE,aAAe,CAChB,AACD,4BACE,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,qBAAuB,CAChC,AACD,sCACE,2BAA+B,CAChC,AACD,gCACE,uBAAwB,AACxB,mBAAoB,AACpB,iBAAmB,AACnB,WAAe,AACf,WAAY,AACZ,kBAAoB,AACpB,mBAAqB,CACtB,AACD,0CACE,YAAc,AACd,mBAAqB,AACrB,UAAY,AACZ,iBAAmB,CACpB","file":"navNew.vue","sourcesContent":["\n.nav[data-v-50de6be9] {\n  margin: 0;\n  padding: 0;\n  height: 2.4rem;\n  background: #16b13a;\n  line-height: 2.4rem;\n  overflow: hidden;\n}\n.nav a[data-v-50de6be9] {\n  width: 24.3%;\n  text-align: center;\n  color: #fff;\n  font-size: 0.9rem;\n  float: left;\n  text-decoration: none !important;\n  position: relative;\n  height: 1.4rem;\n  line-height: 1.4rem;\n  padding: .5rem 0;\n  overflow: hidden;\n  font-weight: bold;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.selected[data-v-50de6be9] {\n  display: inline-block;\n  width: .5rem;\n  height: .4rem;\n  line-height: 1.2rem;\n  background: url(\"../assets/home/home_arrow.png\") no-repeat;\n  background-size: 100% auto;\n  position: absolute;\n  bottom: -0.1rem;\n  left: 50%;\n  margin-left: -0.2rem;\n  z-index: 10;\n}\n.newsSubTit[data-v-50de6be9] {\n  height: 2.2rem;\n  width: 100%;\n  font-size: 0.68rem;\n  line-height: 2.5rem;\n  text-align: center;\n  color: #2d2f32;\n  border-bottom: 0.01rem solid #eff1f4;\n  background: #fff;\n}\n.newsSubTit p[data-v-50de6be9] {\n  height: 2.4rem;\n  overflow: scroll;\n  white-space: nowrap;\n  padding: 0 .8rem;\n  position: relative;\n  top: 0rem;\n  -webkit-overflow-scrolling: touch;\n}\n*[data-v-50de6be9]:not(html) {\n  -webkit-transform: translate3d(0, 0, 0);\n}\n.newsSubTit a[data-v-50de6be9] {\n  display: inline-block;\n  padding: 0 .7rem;\n  position: relative;\n  height: 1.1rem;\n  line-height: 1.1rem;\n  padding: .3rem .7rem;\n  color: #2d2f32;\n  font-size: .9rem;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.newsSubTit p[data-v-50de6be9]::-webkit-scrollbar {\n  display: none;\n}\n.subTitSelected[data-v-50de6be9] {\n  color: #16b13a !important;\n  border-bottom: .15rem solid #16b13a;\n}\n/*stat 三级导航*/\n.thirdTitwrap[data-v-50de6be9] {\n  height: 3.2rem;\n  background: #333d46;\n  overflow: hidden;\n  color: #929cad;\n}\n.thirdTit[data-v-50de6be9] {\n  height: 1.5rem;\n  width: 94%;\n  margin: .8rem auto;\n  line-height: 1.5rem;\n  border: 1px solid #1d2328;\n  border-radius: 0.01rem;\n}\n.thirdTit a[data-v-50de6be9] {\n  width: 25%;\n  color: #929cad;\n  /*display: inline-block;*/\n  float: left;\n  text-align: center;\n  border-right: 1px solid #1d2328;\n  text-decoration: none;\n  box-sizing: border-box;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  font-size: .8rem;\n  padding: 0;\n}\n.thirdTitWidth[data-v-50de6be9] {\n  width: 33.3% !important;\n}\n.thirdTit > a.thirdTitSelected[data-v-50de6be9] {\n  background: #1d2328 !important;\n  color: #fff !important;\n}\n.thirdTit > a[data-v-50de6be9]:last-of-type {\n  border-right: none;\n}\n/*定位*/\n.topFixedWrap[data-v-50de6be9] {\n  width: 100%;\n  z-index: 100;\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0rem;\n}\n.main > .tab-box-fixed[data-v-50de6be9] {\n  position: fixed !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.main > .tab-box-testFix[data-v-50de6be9] {\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-50de6be9] {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.pad[data-v-50de6be9] {\n  margin: 0 3rem;\n}\n.nav-new a[data-v-50de6be9] {\n  width: 18%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: right;\n      -ms-flex-pack: right;\n          justify-content: right;\n}\n.nav-new a .selected[data-v-50de6be9] {\n  margin-left: 0.6rem !important;\n}\n.new-logo-wrap[data-v-50de6be9] {\n  font-family: sans-serif;\n  font-weight: bolder;\n  font-size: 0.88rem;\n  color: #FFFFFF;\n  float: left;\n  margin-left: 0.4rem;\n  letter-spacing: -1px;\n}\n.new-logo-wrap .logo-new[data-v-50de6be9] {\n  width: 0.9rem;\n  margin-right: 0.2rem;\n  top: 0.1rem;\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(184);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'navVue',
    props: ['subtitleData', 'navSelected', 'isThirdTit', 'pad', 'loadingShowProp'],
    data: function data() {
        return {
            subtitData: [],
            thirdTotalTitle: [],
            navMap: {
                'NEWS': '/news',
                'MATCH': '/matchs',
                'VIDEO': '/video',
                'STATS': '/stats'
            },
            currentListData: [],
            loading: false,
            subNavTranslateX: function subNavTranslateX() {},
            stickyFn: function stickyFn() {},
            googlePlayUrl: 'intent://open/#Intent;scheme=allfootball;package=com.allfootball.news;end',
            isExternalAccess: null
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getSubtitChoose', 'getThirdTitChoose']), {
        statsSubTabList: function statsSubTabList() {
            return this.$store.state.navStore.statsSubTabList;
        }
    }),
    created: function created() {
        var _this = this;

        if (this.navSelected === 'STATS') {
            this.statsSubTabList.length && this.statsSubTabList.map(function (elem, i) {
                if (_this.getSubtitChoose === elem.label || i === 0 && !_this.getSubtitChoose) {
                    _this.thirdTotalTitle = elem.urlApi;
                }
            });
            this.$store.commit('setThirdTitChoose', this.thirdTotalTitle.length && this.thirdTotalTitle[0].title || 'Table');
        }
    },
    methods: {
        subNavEmit: function subNavEmit() {},
        thirdNavEmit: function thirdNavEmit() {},
        subTitToggle: function subTitToggle(item, index) {
            var _this2 = this;

            if (this.loadingShowProp) return;
            if (this.getSubtitChoose === item.label) return;

            var subTitle = this.getUrlTitle(item.label);
            if (this.$route.params.subtitle) {
                history.replaceState(null, null, './' + subTitle);
            } else {
                history.replaceState(null, null, this.$route.path + '/' + subTitle);
            }
            this.subNavTranslateX(index);
            this.scrollFn(item.label);
            if (!this.isThirdTit) {
                this.subNavTranslateX(index);
                this.scrollFn(item.label);

                this.$store.commit('setSubtitChoose', item.label);

                var urlApi = item.urlApi;
                if (this.navSelected === 'NEWS') {
                    this.$store.dispatch('newsListApi', { urlApi: urlApi });
                } else if (this.navSelected === 'MATCH') {
                    var finalDate = this.dateToUtc();
                    this.$store.dispatch('matchListApi', { urlApi: urlApi, finalDate: finalDate });
                } else if (this.navSelected === 'VIDEO') {
                    this.$store.dispatch('videoListApi', { urlApi: urlApi, type: 1 });
                }
            } else {
                if (this.navSelected === 'STATS') {
                    var _urlApi = item.urlApi && item.urlApi[0].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') || '';
                    this.statsSubTabList.length && this.statsSubTabList.map(function (elem, i) {
                        if (item.label === elem.label) {
                            _this2.thirdTotalTitle = elem.urlApi;
                        }
                    });
                    this.$store.commit('setSubtitChoose', item.label);
                    this.$store.commit('setThirdTitChoose', 'Table');
                    this.$store.dispatch('statsListApi', { urlApi: _urlApi, thirdTitChoose: 'Table' });
                }
            }
        },
        thirdTitleToggle: function thirdTitleToggle(elem, index) {
            if (this.loadingShowProp) {
                return;
            }
            if (this.getThirdTitChoose === elem.title) {
                return;
            }
            this.$store.commit('setThirdTitChoose', elem.title);
            this.scrollFn(this.getSubtitChoose);
            if (this.navSelected === 'STATS') {
                var urlApi = elem.url && elem.url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') || '';
                this.$store.dispatch('statsListApi', { urlApi: urlApi, thirdTitChoose: elem.title });
            }
        },
        scrollFn: function scrollFn(label) {
            var that = this;
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);

            var headwrap = document.getElementById('headwrap');
            var headHeight = headwrap.offsetHeight;
            var topFixedWrap = document.getElementById('topFixedWrap');

            var contentWrap = document.getElementById('contentWrap');
            if (document.body.scrollTop || document.documentElement.scrollTop >= headwrap.offsetHeight) {
                console.log('*隐藏了下载引导模块');
                this.downLoadHeaderShow = false;
                setTimeout(function () {
                    that.downLoadHeaderShow = true;
                }, 10);
                if (browers.Android) {
                    console.log('*********');

                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    setTimeout(function () {
                        topFixedWrap.className = 'topFixedWrap';
                    }, 10);
                    contentWrap.style.paddingTop = 0 + 'px';
                    console.log(contentWrap.style.paddingTop);
                } else if (browers.iOS) {
                    console.log('&&&&&&&&');
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }

                setTimeout(function () {
                    console.log('**滚了 ', headHeight);
                    document.body.scrollTop = headHeight;
                    document.documentElement.scrollTop = headHeight;
                }, 10);
                console.log('document.body.scrollTop:' + document.body.scrollTop);
            } else {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        },
        dateToUtc: function dateToUtc() {
            var date = new Date();
            var localYear = date.getFullYear();
            var localMonth = date.getMonth() + 1;
            var localDay = date.getDate();
            var localDate = localYear + '/' + localMonth + '/' + localDay + ' 00:00:00';
            var finalLocal = new Date(localDate);
            var finalLocalDate = finalLocal.getTime();
            var diffMin = new Date().getTimezoneOffset();
            var utcTime = finalLocalDate + diffMin * 60 * 1000;
            var utc = new Date(utcTime);
            var y = utc.getFullYear();
            var m = utc.getMonth() + 1;
            var d = utc.getDate();
            var h = utc.getHours();
            var min = utc.getMinutes();
            var s = utc.getSeconds();

            return '' + y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
        }
    },
    mounted: function mounted() {
        this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;
        this.subNavTranslateX = function (index) {
            var scrollBar = document.getElementById('scroll');
            var scrollBarTab = scrollBar.querySelectorAll('a');
            var screenWidth = document.documentElement.clientWidth;
            this.scrollLeft = scrollBar.scrollLeft;
            this.leftToScreen = scrollBarTab[index].getBoundingClientRect().left;
            this.rightToScreen = screenWidth - (this.leftToScreen + scrollBarTab[index].getBoundingClientRect().width);
            var average = (this.leftToScreen + this.rightToScreen) / 2;
            if (this.leftToScreen < this.rightToScreen) {
                scrollBar.scrollLeft -= average - this.leftToScreen;
            } else {
                scrollBar.scrollLeft += average - this.rightToScreen;
            }
        };
    }
});

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixedWrap"
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, _vm._l((_vm.navMap), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": item
      }
    }, [(_vm.navSelected == index) ? _c('span', {
      staticClass: "selected"
    }) : _vm._e(), _vm._v(_vm._s(index) + "\n        ")])
  })), _vm._v(" "), _c('nav', {
    staticClass: "newsSubTit"
  }, [_c('p', {
    staticClass: "newTit",
    attrs: {
      "id": "scroll"
    }
  }, _vm._l((_vm.subtitleData), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'subTitSelected': _vm.getSubtitChoose == item.label, 'pad': _vm.pad
      },
      attrs: {
        "href": ("/" + (_vm.getUrlTitle(_vm.navMap[_vm.navSelected])) + "/" + (_vm.getUrlTitle(item.label)))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.subTitToggle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), (_vm.isThirdTit) ? _c('nav', {
    staticClass: "nav thirdTitwrap"
  }, [_c('div', {
    staticClass: "thirdTit"
  }, _vm._l((_vm.thirdTotalTitle), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'thirdTitSelected': _vm.getThirdTitChoose === item.title, 'thirdTitWidth': _vm.thirdTotalTitle.length < 4
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.thirdTitleToggle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-efb31c00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("56bee19e", content, true);

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".loadwrap[data-v-efb31c00]{bottom:0;left:0;width:100%;height:2rem;color:#8c9399;background:#eff1f4;text-align:center;margin:0!important;line-height:2rem;font-size:.8rem}.loadingicon[data-v-efb31c00]{width:1rem;height:1rem;background:url(" + __webpack_require__(521) + ") no-repeat;background-size:100% 100%;position:absolute;top:.5rem;left:.2rem;animation:rotate-data-v-efb31c00 linear 1.2s both infinite;-webkit-animation:rotate-data-v-efb31c00 linear 1.2s both infinite}.loadingiconStats[data-v-efb31c00]{background:url(" + __webpack_require__(534) + ") no-repeat;background-size:100% 100%}.loading[data-v-efb31c00]{width:7rem;margin:0 auto;height:2rem;line-height:2rem;position:relative}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-data-v-efb31c00{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loadingtext[data-v-efb31c00]{text-indent:1rem;display:inline-block;font-size:.8rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/loading.vue"],"names":[],"mappings":"AACA,2BACE,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,mBAAqB,AACrB,iBAAkB,AAClB,eAAkB,CACnB,AACD,8BACE,WAAY,AACZ,YAAa,AACb,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,UAAW,AACX,WAAa,AACb,2DAA4D,AAC5D,kEAAoE,CACrE,AACD,mCACE,mDAAkE,AAClE,yBAA2B,CAC5B,AACD,0BACE,WAAY,AACZ,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AAeD,kCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AACD,8BACE,iBAAkB,AAClB,qBAAsB,AACtB,eAAkB,CACnB","file":"loading.vue","sourcesContent":["\n.loadwrap[data-v-efb31c00] {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2rem;\n  color: #8c9399;\n  background: #eff1f4;\n  text-align: center;\n  margin: 0 !important;\n  line-height: 2rem;\n  font-size: 0.8rem;\n}\n.loadingicon[data-v-efb31c00] {\n  width: 1rem;\n  height: 1rem;\n  background: url(../assets/home/loading-icon.png) no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: .5rem;\n  left: 0.2rem;\n  animation: rotate-data-v-efb31c00 linear 1.2s both infinite;\n  -webkit-animation: rotate-data-v-efb31c00 linear 1.2s both infinite;\n}\n.loadingiconStats[data-v-efb31c00] {\n  background: url(../assets/stats/loading-icon-stats.png) no-repeat;\n  background-size: 100% 100%;\n}\n.loading[data-v-efb31c00] {\n  width: 7rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  position: relative;\n}\n@-webkit-keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-efb31c00 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-efb31c00 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n.loadingtext[data-v-efb31c00] {\n  text-indent: 1rem;\n  display: inline-block;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon-stats.f719861.png";

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loading',
    data: function data() {
        return {};
    },
    props: ['statsLoading']
});

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadwrap"
  }, [_c('p', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "loadingicon",
    class: {
      'loadingiconStats': _vm.statsLoading
    }
  }), _c('span', {
    staticClass: "loadingtext",
    attrs: {
      "id": "loadingWord"
    }
  }, [_vm._v("loading more")])])])
},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24406857",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("92a4a4de", content, true);

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".noDataWrap[data-v-24406857]{width:100%;margin:0 auto 13.33333333rem;padding:4.4rem 0 3rem}.noDataWrap img[data-v-24406857]{width:9.4rem;display:block;margin:0 auto;height:auto}.sorry[data-v-24406857]{font-size:.9rem;color:#929cad;text-align:center}.grayColor[data-v-24406857]{color:#b5bcc4!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/nodata.vue"],"names":[],"mappings":"AACA,6BACE,WAAY,AACZ,6BAA8B,AAC9B,qBAAuB,CACxB,AACD,iCACE,aAAc,AACd,cAAe,AACf,cAAe,AACf,WAAa,CACd,AACD,wBACE,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,4BACE,uBAA0B,CAC3B","file":"nodata.vue","sourcesContent":["\n.noDataWrap[data-v-24406857] {\n  width: 100%;\n  margin: 0 auto 13.33333333rem;\n  padding: 4.4rem 0 3rem;\n}\n.noDataWrap img[data-v-24406857] {\n  width: 9.4rem;\n  display: block;\n  margin: 0 auto;\n  height: auto;\n}\n.sorry[data-v-24406857] {\n  font-size: .9rem;\n  color: #929cad;\n  text-align: center;\n}\n.grayColor[data-v-24406857] {\n  color: #b5bcc4 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loading',
    data: function data() {
        return {};
    },
    props: ['whiteMode']

});

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noDataWrap"
  }, [(_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": __webpack_require__(542)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": __webpack_require__(522)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sorry",
    class: {
      'grayColor': _vm.whiteMode
    }
  }, [_vm._v("Sorry , no content yet")])])
},staticRenderFns: []}

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/emptyData.d277f30.png";

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("541f91cc", content, true);

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".btn-download,a.btn-download{text-decoration:none!important;display:block;padding:.4rem;margin:1.4rem .7rem 2.5rem;height:1.8rem;line-height:1.8rem;color:#fff;background:#16ac3a;border-radius:.2rem;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadFooter.vue"],"names":[],"mappings":"AACA,6BAEE,+BAAiC,AACjC,cAAe,AACf,cAAe,AACf,2BAAkC,AAClC,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadFooter.vue","sourcesContent":["\n.btn-download,\na.btn-download {\n  text-decoration: none !important;\n  display: block;\n  padding: .4rem;\n  margin: 1.4rem .7rem 2.5rem .7rem;\n  height: 1.8rem;\n  line-height: 1.8rem;\n  color: #fff;\n  background: #16ac3a;\n  border-radius: .2rem;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'downloadFooter',
    data: function data() {
        return {
            isMatch: false,
            isArticle: false
        };
    },
    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(500);
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
            }
            utilObj.jumpUrl();
        }
    },
    mounted: function mounted() {
        if (window.location.href.indexOf('match') > -1) {
            this.isMatch = true;
        } else {
            this.isArticle = true;
        }
    }
});

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMatch) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("Download All Football for more matches")]) : _vm._e(), _vm._v(" "), (_vm.isArticle) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadForComments')))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/video_arrow.04eb228.png";

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("c7ff2126", content, true);

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".listwrap[data-v-1362796c]{height:auto;overflow:hidden}.dateTit[data-v-1362796c]{text-align:center;color:#8c9399;font-size:.8rem;margin:0 auto;height:2rem;line-height:2rem;background:#eff1f4}.list[data-v-1362796c]{height:5.4rem;overflow:hidden;position:relative;border-bottom:1px solid #eff1f4;background:#fff}.list dl[data-v-1362796c]{width:6.4rem}.list dl dt[data-v-1362796c]{width:2.2rem;height:2.2rem;overflow:hidden;text-align:center;margin:0 auto .4rem}.list dl dt img[data-v-1362796c]{width:100%;display:block}.list dl dd[data-v-1362796c]{text-align:center;font-size:.68rem;color:#606369;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.flwrap[data-v-1362796c]{float:left;margin:.9rem 0 .9rem .6rem}.frwrap[data-v-1362796c]{float:right;margin:.9rem .6rem .9rem 0}.line[data-v-1362796c]{width:.6rem;height:.12rem;display:inline-block;background:#333d46;position:relative;top:-.4rem;margin:0 1rem}.competewrap[data-v-1362796c]{box-sizing:border-box;font-size:1.2rem;width:10.4rem;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);text-align:center;margin-top:.58rem}.competename[data-v-1362796c]{font-size:12px;line-height:14px;color:#8c9399;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.compete-center[data-v-1362796c]{margin:.43rem 0}.status[data-v-1362796c]{font-size:12px;line-height:14px;color:#8c9399}.list a[data-v-1362796c]{display:block}.dot[data-v-1362796c]{color:#16b13a;width:2rem;display:inline-block;position:relative;top:-.04rem;font-size:1rem;font-style:normal}.playingScore[data-v-1362796c],playingLive[data-v-1362796c]{color:#16b13a;margin-bottom:.4rem;line-height:1.2rem}.playingUnliveTime[data-v-1362796c]{color:#16b13a;font-size:.8rem}.statusPlaying_competewrap .competename[data-v-1362796c]{margin-bottom:.4rem}.playingLiveTime[data-v-1362796c]{width:6rem;height:1rem;background:#16b13a;margin:0 auto;color:#fff;font-size:.6rem;line-height:1rem;border-radius:.02rem}.video_arrow[data-v-1362796c]{width:.36rem;height:.5rem;float:left;margin:.3rem .2rem 0 .5rem}.unStart_competewrap[data-v-1362796c]{color:#606369;font-size:1rem}.statusPlaying_competewrap[data-v-1362796c]{color:#16b13a}.statusEnd_competewrap[data-v-1362796c]{color:#2d2f32}.vs[data-v-1362796c]{line-height:1.2rem;color:#606369;font-size:1.2rem;margin:.59rem 0}.unStartLive[data-v-1362796c]{color:#16ac3a;font-size:.6rem;width:2.4rem;height:1rem;border:1px solid #16ac3a;display:inline-block;line-height:1rem;border-radius:.01rem;position:relative;left:-.1rem;top:0;-webkit-transform:scale(.7);transform:scale(.7)}.unStartTime[data-v-1362796c]{color:#8c9399;font-size:.68rem;line-height:12px}.loadwrap[data-v-1362796c]{bottom:0;left:0;width:100%;height:2rem;color:#8c9399;background:#eff1f4;text-align:center;margin:0!important;line-height:2rem;font-size:.68rem}.loadingicon[data-v-1362796c]{width:1rem;height:1rem;background:url(" + __webpack_require__(521) + ") no-repeat;background-size:100% 100%;position:absolute;top:.5rem;left:0;animation:rotate-data-v-1362796c linear 1.2s both infinite;-webkit-animation:rotate-data-v-1362796c linear 1.2s both infinite}.loading[data-v-1362796c]{width:6rem;margin:0 auto;height:2rem;line-height:2rem;position:relative}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-data-v-1362796c{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loadingtext[data-v-1362796c]{text-indent:.4rem;display:inline-block}.contentWrap[data-v-1362796c]{min-height:38rem}.operamini-tips[data-v-1362796c]{background:#ff0;text-align:center;font-weight:700}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/pages/AppMatch.vue"],"names":[],"mappings":"AACA,2BACE,YAAa,AACb,eAAiB,CAClB,AACD,0BACE,kBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACrB,AACD,uBACE,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,gCAAiC,AACjC,eAAiB,CAClB,AACD,0BACE,YAAc,CACf,AACD,6BACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,mBAAqB,CACtB,AACD,iCACE,WAAY,AACZ,aAAe,CAChB,AACD,6BACE,kBAAmB,AACnB,iBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,yBACE,WAAY,AACZ,0BAA4B,CAC7B,AACD,yBACE,YAAa,AACb,0BAA4B,CAC7B,AACD,uBACE,YAAa,AACb,cAAe,AACf,qBAAsB,AACtB,mBAAoB,AACpB,kBAAmB,AACnB,WAAa,AACb,aAAe,CAChB,AACD,8BACE,sBAAuB,AACvB,iBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,SAAU,AACV,mCAAoC,AAC5B,2BAA4B,AACpC,kBAAmB,AACnB,iBAAmB,CACpB,AACD,8BACE,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,iCACE,eAAiB,CAClB,AACD,yBACE,eAAgB,AAChB,iBAAkB,AAClB,aAAe,CAChB,AACD,yBACE,aAAe,CAChB,AACD,sBACE,cAAe,AACf,WAAY,AACZ,qBAAsB,AACtB,kBAAmB,AACnB,YAAc,AACd,eAAgB,AAChB,iBAAmB,CACpB,AACD,4DAEE,cAAe,AACf,oBAAsB,AACtB,kBAAoB,CACrB,AACD,oCACE,cAAe,AACf,eAAkB,CACnB,AACD,yDACE,mBAAsB,CACvB,AACD,kCACE,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,cAAe,AACf,WAAY,AACZ,gBAAkB,AAClB,iBAAkB,AAClB,oBAAuB,CACxB,AACD,8BACE,aAAe,AACf,aAAe,AACf,WAAY,AACZ,0BAA+B,CAChC,AACD,sCACE,cAAe,AACf,cAAgB,CACjB,AACD,4CACE,aAAe,CAChB,AACD,wCACE,aAAe,CAChB,AACD,qBACE,mBAAoB,AACpB,cAAe,AACf,iBAAkB,AAClB,eAAkB,CACnB,AACD,8BACE,cAAe,AACf,gBAAkB,AAClB,aAAc,AACd,YAAa,AACb,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,qBAAuB,AACvB,kBAAmB,AACnB,YAAc,AACd,MAAU,AACV,4BAA8B,AACtB,mBAAsB,CAC/B,AACD,8BACE,cAAe,AACf,iBAAmB,AACnB,gBAAkB,CACnB,AACD,2BACE,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,mBAAqB,AACrB,iBAAkB,AAClB,gBAAmB,CACpB,AACD,8BACE,WAAY,AACZ,YAAa,AACb,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,UAAW,AACX,OAAW,AACX,2DAA4D,AAC5D,kEAAoE,CACrE,AACD,0BACE,WAAY,AACZ,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AAeD,kCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AACD,8BACE,kBAAoB,AACpB,oBAAsB,CACvB,AACD,8BACE,gBAAkB,CACnB,AACD,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB","file":"AppMatch.vue","sourcesContent":["\n.listwrap[data-v-1362796c] {\n  height: auto;\n  overflow: hidden;\n}\n.dateTit[data-v-1362796c] {\n  text-align: center;\n  color: #8c9399;\n  font-size: .8rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  background: #eff1f4;\n}\n.list[data-v-1362796c] {\n  height: 5.4rem;\n  overflow: hidden;\n  position: relative;\n  border-bottom: 1px solid #eff1f4;\n  background: #fff;\n}\n.list dl[data-v-1362796c] {\n  width: 6.4rem;\n}\n.list dl dt[data-v-1362796c] {\n  width: 2.2rem;\n  height: 2.2rem;\n  overflow: hidden;\n  text-align: center;\n  margin: 0 auto .4rem;\n}\n.list dl dt img[data-v-1362796c] {\n  width: 100%;\n  display: block;\n}\n.list dl dd[data-v-1362796c] {\n  text-align: center;\n  font-size: 0.68rem;\n  color: #606369;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.flwrap[data-v-1362796c] {\n  float: left;\n  margin: .9rem 0 .9rem .6rem;\n}\n.frwrap[data-v-1362796c] {\n  float: right;\n  margin: .9rem .6rem .9rem 0;\n}\n.line[data-v-1362796c] {\n  width: .6rem;\n  height: .12rem;\n  display: inline-block;\n  background: #333d46;\n  position: relative;\n  top: -0.4rem;\n  margin: 0 1rem;\n}\n.competewrap[data-v-1362796c] {\n  box-sizing: border-box;\n  font-size: 1.2rem;\n  width: 10.4rem;\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  text-align: center;\n  margin-top: .58rem;\n}\n.competename[data-v-1362796c] {\n  font-size: 12px;\n  line-height: 14px;\n  color: #8c9399;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.compete-center[data-v-1362796c] {\n  margin: .43rem 0;\n}\n.status[data-v-1362796c] {\n  font-size: 12px;\n  line-height: 14px;\n  color: #8c9399;\n}\n.list a[data-v-1362796c] {\n  display: block;\n}\n.dot[data-v-1362796c] {\n  color: #16b13a;\n  width: 2rem;\n  display: inline-block;\n  position: relative;\n  top: -0.04rem;\n  font-size: 1rem;\n  font-style: normal;\n}\n.playingScore[data-v-1362796c],\nplayingLive[data-v-1362796c] {\n  color: #16b13a;\n  margin-bottom: 0.4rem;\n  line-height: 1.2rem;\n}\n.playingUnliveTime[data-v-1362796c] {\n  color: #16b13a;\n  font-size: 0.8rem;\n}\n.statusPlaying_competewrap .competename[data-v-1362796c] {\n  margin-bottom: 0.4rem;\n}\n.playingLiveTime[data-v-1362796c] {\n  width: 6rem;\n  height: 1rem;\n  background: #16b13a;\n  margin: 0 auto;\n  color: #fff;\n  font-size: 0.6rem;\n  line-height: 1rem;\n  border-radius: 0.02rem;\n}\n.video_arrow[data-v-1362796c] {\n  width: 0.36rem;\n  height: 0.5rem;\n  float: left;\n  margin: 0.3rem 0.2rem 0 0.5rem;\n}\n.unStart_competewrap[data-v-1362796c] {\n  color: #606369;\n  font-size: 1rem;\n}\n.statusPlaying_competewrap[data-v-1362796c] {\n  color: #16b13a;\n}\n.statusEnd_competewrap[data-v-1362796c] {\n  color: #2d2f32;\n}\n.vs[data-v-1362796c] {\n  line-height: 1.2rem;\n  color: #606369;\n  font-size: 1.2rem;\n  margin: 0.59rem 0;\n}\n.unStartLive[data-v-1362796c] {\n  color: #16ac3a;\n  font-size: 0.6rem;\n  width: 2.4rem;\n  height: 1rem;\n  border: 1px solid #16ac3a;\n  display: inline-block;\n  line-height: 1rem;\n  border-radius: 0.01rem;\n  position: relative;\n  left: -0.1rem;\n  top: 0rem;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n}\n.unStartTime[data-v-1362796c] {\n  color: #8c9399;\n  font-size: 0.68rem;\n  line-height: 12px;\n}\n.loadwrap[data-v-1362796c] {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2rem;\n  color: #8c9399;\n  background: #eff1f4;\n  text-align: center;\n  margin: 0 !important;\n  line-height: 2rem;\n  font-size: 0.68rem;\n}\n.loadingicon[data-v-1362796c] {\n  width: 1rem;\n  height: 1rem;\n  background: url(../assets/home/loading-icon.png) no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: .5rem;\n  left: 0rem;\n  animation: rotate-data-v-1362796c linear 1.2s both infinite;\n  -webkit-animation: rotate-data-v-1362796c linear 1.2s both infinite;\n}\n.loading[data-v-1362796c] {\n  width: 6rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  position: relative;\n}\n@-webkit-keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-1362796c {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-1362796c {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n.loadingtext[data-v-1362796c] {\n  text-indent: 0.4rem;\n  display: inline-block;\n}\n.contentWrap[data-v-1362796c] {\n  min-height: 38rem;\n}\n.operamini-tips[data-v-1362796c] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_downloadHeader_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_downloadHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_downloadHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_downloadFooter_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_downloadFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_downloadFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_navNew_vue__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_navNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_navNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loading_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_nodata_vue__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_nodata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_nodata_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_downloadPopup_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_downloadPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_downloadPopup_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            currentNavTag: 'MATCH',

            downLoadHeaderShow: true,

            scroll: 0,

            is_jump: true,
            isOperamini: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['getMatchSubTabList', 'getMatchLoading', 'getMatchNoDataMode', 'getMatchLoadingShow', 'getDownloadFooterShow', 'getCurrentMatchListData', 'getFinalListSplitDateData']), {
        subtitChoose: function subtitChoose() {
            return this.$store.state.navStore.subtitChoose;
        }
    }),
    asyncData: function asyncData(_ref) {
        var _this = this;

        var store = _ref.store,
            subtitle = _ref.route.params.subtitle;

        var date = new Date();
        var localYear = date.getFullYear();
        var localMonth = date.getMonth() + 1;
        var localDay = date.getDate();
        var localDate = localYear + '/' + localMonth + '/' + localDay + ' 00:00:00';
        var finalLocal = new Date(localDate);
        var local_date = finalLocal.getTime();
        var diff_min = new Date().getTimezoneOffset();
        var utcTime = local_date + diff_min * 60 * 1000;
        var utc = new Date(utcTime);
        var y = utc.getFullYear();
        var m = utc.getMonth() + 1;
        var d = utc.getDate();
        var h = utc.getHours();
        var min = utc.getMinutes();
        var s = utc.getSeconds();
        var finalDate = '' + y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
        console.log('--subtitle---', subtitle);
        var allFetch = function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var menus, chooseArr, urlApi, matchList;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return store.dispatch('menusListApi', { subtitle: subtitle, type: 'MATCH' });

                            case 2:
                                menus = _context.sent;
                                chooseArr = store.getters.getMatchSubTabList.filter(function (ele) {
                                    return ele.label === store.state.navStore.subtitChoose;
                                });
                                urlApi = chooseArr && chooseArr.length && chooseArr[0].urlApi || '';
                                _context.next = 7;
                                return store.dispatch('matchListApi', { urlApi: urlApi, finalDate: finalDate });

                            case 7:
                                matchList = _context.sent;
                                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([menus, matchList]));

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function allFetch() {
                return _ref2.apply(this, arguments);
            };
        }();
        return allFetch();
    },

    created: function created() {},
    mounted: function mounted() {
        var that = this;
        this.onScroll = function () {
            var utilObj = __webpack_require__(500);
            utilObj.lazyload('listwrap', 'teamlogo');
            that.stickyFn();
        };
        window.addEventListener('scroll', this.onScroll, false);
        var utilObj = __webpack_require__(500);
        utilObj.timeForInOut();
        this.isOperamini = utilObj.checkOperamini();
    },
    updated: function updated() {
        console.log('update:||||||||');
        var utilObj = __webpack_require__(500);
        utilObj.lazyload('listwrap', 'teamlogo');
    },
    head: function head() {
        var referer = this.subtitChoose;
        return {
            link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: 'https://www.allfootballapp.com/match'
            }],
            title: referer + ' football matchs\uFF0CLive Scores\uFF0CMatch analysis | All Football',
            meta: [{
                name: 'description',
                content: 'The ' + referer + ' football match details, including live text commentary, team line-ups, match analysis, odds...'
            }, {
                name: 'keywords',
                content: 'football app, allfootballapp.com,  ' + referer + ' matchs, All Football, ' + referer + ' live scores, ' + referer + ' scores, '
            }]
        };
    },

    methods: {
        tran12: function tran12(time) {
            var time_arr = time.split(':');
            if (time_arr[0] > 12) {
                var result = time_arr[0] - 12 + ':' + time_arr[1] + ' FM';
            } else {
                var result = time_arr[0] + ':' + time_arr[1] + ' AM';
            }
            return result;
        },
        setAnchor: function setAnchor(isLastEnd, index) {
            if (isLastEnd && index != 1) {
                this.is_jump = true;
                return 'there';
            }
        },

        subNavTranslateX: function subNavTranslateX(index) {
            var screenWidth = document.documentElement.clientWidth;
            this.scrollLeft = document.getElementById('scroll').scrollLeft;
            this.leftToScreen = $('#scroll span').eq(index)[0].getBoundingClientRect().left;
            this.rightToScreen = screenWidth - ($('#scroll span').eq(index)[0].getBoundingClientRect().left + $('#scroll span').eq(index).width());
            var average = (this.leftToScreen + this.rightToScreen) / 2;
            if (this.leftToScreen < this.rightToScreen) {
                document.getElementById('scroll').scrollLeft -= average - this.leftToScreen;
            } else {
                document.getElementById('scroll').scrollLeft += average - this.rightToScreen;
            }
        },
        stickyFn: function stickyFn(ev) {
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                var topFixedWrap = document.getElementById('topFixedWrap');
                if (!topFixedWrap) {
                    return;
                }
                var topFixedWrapHeight = topFixedWrap.offsetHeight;
                this.scroll = document.body.scrollTop;
                var headwrap = document.getElementById('headwrap');
                var headHeight = headwrap.offsetHeight;
                var contentWrap = document.getElementById('contentWrap');
                if (this.scroll >= headHeight) {
                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                } else {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        }
    },
    components: {
        downloadheader: __WEBPACK_IMPORTED_MODULE_6__components_downloadHeader_vue___default.a, downloadfooter: __WEBPACK_IMPORTED_MODULE_7__components_downloadFooter_vue___default.a, navVue: __WEBPACK_IMPORTED_MODULE_8__components_navNew_vue___default.a, loading: __WEBPACK_IMPORTED_MODULE_9__components_loading_vue___default.a, nodata: __WEBPACK_IMPORTED_MODULE_10__components_nodata_vue___default.a, downloadPopup: __WEBPACK_IMPORTED_MODULE_11__components_downloadPopup_vue___default.a
    }
});

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n        professional APP.")]) : _vm._e(), _vm._v(" "), _c('downloadheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadHeaderShow),
      expression: "downLoadHeaderShow"
    }],
    attrs: {
      "id": "headwrap"
    }
  }), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getMatchSubTabList,
      "navSelected": _vm.currentNavTag
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.getMatchNoDataMode && !_vm.getMatchLoadingShow) ? _c('nodata', {
    attrs: {
      "whiteMode": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.getMatchNoDataMode && !_vm.getMatchLoadingShow) ? _c('div', {
    staticClass: "listwrap",
    attrs: {
      "id": "listwrap"
    }
  }, [_vm._l((_vm.getFinalListSplitDateData), function(item, key, index) {
    return _c('div', {
      key: index
    }, [_c('p', {
      staticClass: "dateTit"
    }, [_c('span', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('em', [_vm._v(_vm._s(item.localdate))])]), _vm._v(" "), _vm._l((item), function(elem, index) {
      return _c('div', {
        key: index,
        staticClass: "sameDateData",
        attrs: {
          "id": _vm.setAnchor(elem.isLastEnd, index)
        }
      }, [_c('div', {
        staticClass: "list"
      }, [_c('a', {
        staticClass: "clearfix",
        attrs: {
          "href": ("/match/" + _vm.subtitChoose + "/" + (elem.team_A_name.replace(/\s/g, '-')) + "-vs-" + (elem.team_B_name.replace(/\s/g, '-')) + "/" + (elem.match_id))
        }
      }, [_c('dl', {
        staticClass: "flwrap"
      }, [_c('dt', [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamlogo",
        attrs: {
          "data-src": _vm.getImgSrc(elem.team_A_logo)
        }
      })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(elem.team_A_name))])]), _vm._v(" "), (elem.status === 'Fixture') ? _c('div', {
        staticClass: "unStart_competewrap competewrap"
      }, [_c('div', {
        staticClass: "unStartInfor"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v(_vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek))]), _vm._v(" "), _c('p', {
        staticClass: "vs"
      }, [_vm._v("vs")]), _vm._v(" "), _c('p', {
        staticClass: "unStartTime"
      }, [(elem.webLivingFlag) ? _c('span', {
        staticClass: "unStartLive"
      }, [_vm._v("LIVE")]) : _vm._e(), _vm._v(_vm._s(_vm.tran12(elem.localdate.local_hms)) + "\n                                    ")])])]) : _vm._e(), _vm._v(" "), (elem.status === 'Postponed' || elem.status === 'Cancelled' || elem.status === 'Suspended') ? _c('div', {
        staticClass: "unStart_competewrap competewrap"
      }, [_c('div', {
        staticClass: "unStartInfor"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v(_vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek))]), _vm._v(" "), _c('p', {
        staticClass: "vs"
      }, [_vm._v("vs")]), _vm._v(" "), _c('p', {
        staticClass: "unStartTime"
      }, [(elem.webLivingFlag) ? _c('span', {
        staticClass: "unStartLive"
      }, [_vm._v("LIVE")]) : _vm._e(), _vm._v(_vm._s(elem.status) + "\n                                    ")])])]) : _vm._e(), _vm._v(" "), (elem.status === 'Playing') ? _c('div', {
        staticClass: "statusPlaying_competewrap competewrap"
      }, [_c('div', {
        staticClass: "playingUnLive"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v(_vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek))]), _vm._v(" "), _c('p', {
        staticClass: "playingScore"
      }, [_c('span', [_vm._v(_vm._s(elem.fs_A))]), _c('em', {
        staticClass: "dot"
      }, [_vm._v(":")]), _c('span', [_vm._v(_vm._s(elem.fs_B))])]), _vm._v(" "), (!elem.webLivingFlag) ? _c('p', {
        staticClass: "playingUnliveTime"
      }, [_vm._v("\n                                        " + _vm._s(elem.playing_time) + "'")]) : _vm._e(), _vm._v(" "), (elem.webLivingFlag) ? _c('p', {
        staticClass: "playingLiveTime"
      }, [_c('img', {
        staticClass: "video_arrow",
        attrs: {
          "src": __webpack_require__(557)
        }
      }), _c('span', {
        staticClass: "fl"
      }, [_vm._v("LIVE IN " + _vm._s(elem.playing_time) + "'")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (elem.status === 'Played') ? _c('div', {
        staticClass: "statusEnd_competewrap competewrap"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v(_vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek))]), _vm._v(" "), _c('p', {
        staticClass: "compete-center mb5"
      }, [_c('span', [_vm._v(_vm._s(elem.fs_A))]), _c('em', {
        staticClass: "line"
      }), _c('span', [_vm._v(_vm._s(elem.fs_B))])]), _vm._v(" "), _c('p', {
        staticClass: "status"
      }, [_vm._v("end")])]) : _vm._e(), _vm._v(" "), _c('dl', {
        staticClass: "frwrap"
      }, [_c('dt', [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamlogo",
        attrs: {
          "data-src": _vm.getImgSrc(elem.team_B_logo)
        }
      })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(elem.team_B_name))])])])])])
    })], 2)
  }), _vm._v(" "), (_vm.getDownloadFooterShow) ? _c('downloadfooter', {
    attrs: {
      "text": "Download All Football for more matches"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.getMatchLoadingShow) ? _c('loading') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.7b1c83477106bfe754cb.js